import styled from 'styled-components'

export const StyledMenuDivider = styled.div`
  border-bottom: 1px solid ${props => props.theme.menu.colors.neutral.light};
  margin: 0 -${props => props.theme.spacings.small};
`
